import { isValidURL } from '@/utils/url.utils.js'

const KV_SYNC_UPDATE_KEY_VALUE_ACTION = 'kvSync/updateKeyValueAction'

const UpdateResourcePropertyPlugin = (store) => {
  store.subscribeAction(async (action) => {
    if (action.type != KV_SYNC_UPDATE_KEY_VALUE_ACTION) return
    if (!action.payload || !action.payload.key || typeof (action.payload.key) != 'string') return

    const topic = action.payload.key
    const message = action.payload.value
    const topicParts = topic.split('/')
    const [, resourceName, resourceId, propertyName] = topicParts // ignore the first part, that is the topic prefix and we dont care
    const propertyValue = message
    if (!resourceName || !resourceId || !propertyName || !propertyValue) return
    if (propertyName.endsWith('Url') && isValidURL(propertyValue)) { // example: canvasBlocksUrl
      const propertyData = await fetch(propertyValue).then((res) => res.json()).then((body) => (body))
      if (!propertyData) return
      const contentPropertyName = propertyName.replace('Url', '')
      store.dispatch('resource/updateResourceByIdAction', {
        resourceName,
        id: resourceId,
        propertyName: contentPropertyName,
        propertyValue: propertyData,
      })
    } else {
      store.dispatch('resource/updateResourceByIdAction', {
        resourceName,
        id: resourceId,
        propertyName,
        propertyValue,
      })
    }
  })
}

export default UpdateResourcePropertyPlugin
